export default __webpack_public_path__ + "static/media/outstanding.055cf361.svg";